
let readyPromise = null;

export const setAddonWidgetReady = (promise) => {
    readyPromise = promise;
};

export const whenAddonWidgetReady = () => readyPromise || Promise.resolve();
